// PO Pilot date + currency formatters shared across pages.

// Format a Go-side ISO datetime to a locale date+time string.
export function fmtDateTime(dateStr?: string): string {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleString();
}

// Format a date-only string (YYYY-MM-DD or full ISO) to a locale date.
//
// Go serialises `expected_arrival` as bare YYYY-MM-DD (date-only, no
// timezone). Parsing bare YYYY-MM-DD via new Date() treats them as
// UTC-midnight, which renders as the previous day for users west of UTC.
// Appending T12:00:00 anchors to local noon and avoids the off-by-one
// for all UTC-12..UTC+12 zones.
export function fmtDate(dateStr?: string): string {
  if (!dateStr) return '—';
  const safe = /^\d{4}-\d{2}-\d{2}$/.test(dateStr) ? dateStr + 'T12:00:00' : dateStr;
  return new Date(safe).toLocaleDateString();
}

// Format a monetary amount with currency code (e.g. "USD 12.34"
// or "$12.34" depending on Intl support).
export function currencyFmt(amount: number, currency: string): string {
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency,
    }).format(amount);
  } catch {
    return `${currency} ${amount.toFixed(2)}`;
  }
}
